module.exports = __webpack_public_path__ + "static/media/splash.b48084ad.png";